import { FieldCard } from './FileCard';

type FieldsGridProps<T extends string> = {
  fields: readonly T[];
  getTitle: (field: T) => React.ReactNode;
  renderField: (field: T) => React.ReactNode;
};

export function FieldsGrid<T extends string>({
  fields,
  getTitle,
  renderField
}: FieldsGridProps<T>) {
  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
      {fields.map((field) => (
        <FieldCard key={field} title={getTitle(field)}>
          {renderField(field)}
        </FieldCard>
      ))}
    </div>
  );
}
